import { H5, P } from "../../../../AbstractElements";
import { ActivityLogData } from "../../../../Data/Applications/SocialApp/SocialApp";
import { MyActivityProp } from "../../../../Types/SocialAppType";

const MyActivity: React.FC<MyActivityProp> = ({ heading }) => {
  return (
    <div className="my-activity">
      <H5 className="mb-3">{heading}</H5>
      {ActivityLogData.map((item) => (
        <P key={item.id}>
          <span>{item.icon}</span>
          {item.description}
        </P>
      ))}
    </div>
  );
};

export default MyActivity;
